<template>
  <div class="nav-box" v-if="$store.state[$store.state.view + 'Module'].client != null">

    <div class="nav-box-header">Client application</div>

    <router-link 
      :to="{
        name : 'application-applicant-profile', 
        params : {
          clientId   : $store.state[$store.state.view + 'Module'].client.id,
          applicantId: $store.state[$store.state.view + 'Module'].client.applicants[0].id
        }
      }"
      tag="a"
      :class="{ 'flex items-center block nav-item mt-1' : true, 'selected' : $route.path.indexOf('/profile') > -1 || $route.path.indexOf('/contact') > -1 || $route.path.indexOf('/address') > -1 || $route.path.indexOf('/employment') > -1 }" >
      
      <div v-tooltip.bottom="{ html : 'applicant-list' }">Applicants</div>

      <div id="applicant-list" class="pb-1">
        <template v-for="(applicant, index) in $store.state[$store.state.view + 'Module'].client.applicants">
          <router-link 
            :to="{
              name : 'application-applicant-profile', 
              params : {
                clientId   : applicant.client_id,
                applicantId: applicant.id
              }
            }"
            tag="a" class="mt-1 block text-white no-underline hover:underline">{{ getApplicantName(applicant) }}</router-link>
        </template>
      </div>

      <button class="font-semibold text-white uppercase bg-gray-600 rounded-sm hover:bg-gray-700 ml-4" 
        style="font-size:9px;padding:3px 5px;" 
        v-tooltip.bottom="{ html : 'addApplicantOptions' }">+ Add</button>
      
      <div id="addApplicantOptions" class="">
        <a href="#"
          class="block text-white no-underline hover:underline text-sm"
          @click.prevent="addApplicant('person')">Applicant</a>

        <a href="#"
          class="block text-white no-underline hover:underline text-sm"
          @click.prevent="addApplicant('company')">Company</a>

        <a href="#"
          class="block text-white no-underline hover:underline text-sm"
          @click.prevent="addApplicant('trust')">Trust</a>
      </div>
    </router-link>

    <!-- for applicant section -->
    <template v-if="$route.name.indexOf('applicant') > -1">
      <ApplicantNavigation
        v-bind:enableDelete="false"
        v-bind:enableMove="false"></ApplicantNavigation>
    </template>

    <router-link 
      :to="{ 
        name  : 'application-requirement',
        params: {
          clientId : $route.params.clientId
        }
      }" 
      tag="a"
      v-if="isPageVisible('requirements')"
      :class="{ 
        'nav-item': true,
        'selected': $route.name == 'application-requirement' 
      }">Requirements</router-link>

    <router-link 
      :to="{ 
        name  : 'application-asset',
        params: {
          clientId : $route.params.clientId
        }
      }" 
      tag="a"
      v-if="isPageVisible('assets')"
      :class="{ 
        'nav-item': true, 
        'selected': $route.name == 'application-asset' 
      }">Assets</router-link>




    <template v-if="$store.state[$store.state.view + 'Module'].broker.suspended">
      <a href="#" class="nav-item disabled" @click.prevent="showSuspendedModal()">Liabilities</a>
    </template>

    <template v-else>
      <router-link 
        :to="{ 
          name  : 'application-liability',
          params: {
            clientId : $route.params.clientId
          }
        }" 
        tag="a"
        v-if="isPageVisible('liabilities')"
        :class="{ 
          'nav-item': true, 
          'selected': $route.name == 'application-liability' 
        }">Liabilities</router-link>
    </template>



    <template v-if="$store.state[$store.state.view + 'Module'].broker.suspended">
      <a href="#" class="nav-item disabled" @click.prevent="showSuspendedModal()">Living Expenses</a>
    </template>

    <template v-else>
      <router-link 
        :to="{ 
          name  : 'application-expense',
          params: {
            clientId : $route.params.clientId
          }
        }" 
        tag="a"
        v-if="isPageVisible('expenses')"
        :class="{ 
          'nav-item' : true, 
          'selected' : $route.name == 'application-expense' 
        }">Living Expenses</router-link>
    </template>




    <template v-if="$store.state[$store.state.view + 'Module'].broker.suspended">
      <a href="#" class="nav-item disabled" @click.prevent="showSuspendedModal()">Risk Profile</a>
    </template>

    <template v-else>
      <router-link 
        :to="{ 
          name  : 'application-risk-profile',
          params: {
            clientId : $route.params.clientId
          }
        }" 
        tag="a"
        v-if="isPageVisible('risk-profiles')"
        :class="{ 
          'nav-item' : true, 
          'selected' : $route.name == 'application-risk-profile' 
        }">Risk Profile</router-link>
    </template>




    <template v-if="$store.state[$store.state.view + 'Module'].broker.suspended">
      <a href="#" class="nav-item disabled" @click.prevent="showSuspendedModal()">Documents</a>
    </template>

    <template v-else>
      <router-link
        :to="{
          name  : 'application-document',
          params: {
            clientId   : $route.params.clientId,
            applicantId: $store.state[$store.state.view + 'Module'].client.applicants[0].id
          }
        }"
        tag="a"
        v-if="isPageVisible('documents')"
        :class="{
          'nav-item' : true,
          'selected' : $route.name.indexOf('document') > -1
        }">Documents</router-link>

      <!-- for applicant section -->
      <template v-if="$route.name.indexOf('document') > -1">
        <ApplicantNavigation
          v-bind:enableDelete="false"
          v-bind:enableMove="false"></ApplicantNavigation>
      </template>
    </template>



    <template v-if="$store.state[$store.state.view + 'Module'].broker.suspended">
      <a href="#" class="nav-item disabled" @click.prevent="showSuspendedModal()">Submit</a>
    </template>

    <template v-else>
      <router-link 
        :to="{ name: $store.state.view == 'broker' ? 'application-submit-broker' : 'application-submit-client' }" 
        tag="a"
        :class="{ 
          'nav-item mb-1': true, 
          'disabled'     : $store.state[$store.state.view + 'Module'].broker.suspended,
          'selected'     : $route.path.indexOf('/submit/') > -1 
        }">Submit</router-link>
    </template>


    <template v-if="$store.state.view == 'broker'">
      <a href="#" :class="{ 'nav-item border-t border-gray-400 pt-2': true }" @click.prevent="toggleNotepad()">Notes</a>

      <template v-if="$store.state[$store.state.view + 'Module'].broker.suspended">
        <a href="#" class="nav-item disabled" @click.prevent="showSuspendedModal()">View Client Information Form</a>
        <a href="#" class="nav-item disabled" @click.prevent="showSuspendedModal()">Download All Documents</a>
        <a href="#" class="nav-item disabled" @click.prevent="showSuspendedModal()">Upload to Mercury</a>
      </template>

      <template v-else>
        <a :href="getBackendHost + '/api/report/preview/' + $route.params.clientId + '?token=' + getJwt"
          target="_blank" 
          class="nav-item">View Client Information Form</a>

        <a href="#"
          class="nav-item"
          @click.prevent="downloadAllAsZip($route.params.clientId, getApplicantName($store.state[$store.state.view + 'Module'].client.applicants[0]))"
          v-if="$store.state[$store.state.view + 'Module'].client.num_documents_received != null && $store.state[$store.state.view + 'Module'].client.num_documents_received > 0">Download All Documents</a>

        <template v-if="showMercuryOption">
          <router-link
            :to="{ name: 'application-mercury-confirm' }"
            tag="a"
            :class="{ 'nav-item mb-1' : true, 'selected' : $route.path.indexOf('/mercury') > -1 }">Upload to Mercury</router-link>
        </template>

        <!-- <template v-if="isUserAdmin">
          <a href="#" class="nav-item" @click.prevent="showCommModal($route.params.clientId)">Message Client</a>
        </template> -->
      </template>
    </template>
  </div>
</template>

<script>
  import ApplicantNavigation  from './ApplicantNavigation'

  export default {

    components : {
      ApplicantNavigation
    },

    methods : {
      addApplicant(type) {
        this.showLoader("Adding an applicant...")
        this.apiPost({
          clientId: this.$route.params.clientId,
          type          
        }, 'applicant/create', (applicant) => {

          this.getClient({
            force   : true,
            clientId: this.$route.params.clientId
          }, (client) => {
            this.hideLoader()
            this.client = client

            // once this is set, we can take the user to newly added applicant page
            this.$router.push({ 
              name  : 'application-applicant-profile',
              params: {
                clientId   : this.$route.params.clientId,
                applicantId: applicant.id
              }
            })
          })
        })
      }

    }
  }
</script>